export const physiologyModule = {
  id: "physiology",
  title: "Liver Physiology",
  sections: [
    {
      type: "text",
      content:
        "<p>The liver performs over 500 vital functions including metabolism, detoxification, and protein synthesis. This module covers hepatic metabolism, bile production, and blood filtration.</p>",
    },
    {
      type: "text",
      content:
        "<p>Content coming soon. Add your physiology content here.</p>",
    },
  ],
};
